import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { PreviewState, PreviewStore } from './preview.store';
import { PreviewTypeId } from '../models/preview.model';
import { MixedLoyaltyItem } from '../../loyalty/shared/models/mixed-loyalty-item.model';

@Injectable({ providedIn: 'root' })
export class PreviewQuery extends QueryEntity<PreviewState> {
  PreviewTypeId = PreviewTypeId;
  constructor(protected store: PreviewStore) {
    super(store);
  }

  getAllScoreCard() {
    return this.getAll({ filterBy: (entity) => entity._id.includes(PreviewTypeId.scorecard) });
  }
  getAllMarketplace() {
    return this.getAll({ filterBy: (entity) => entity._id.includes(PreviewTypeId.marketplace) }).map(marketplace => new MixedLoyaltyItem({ type: 'marketplace', data: marketplace }));
  }
  getAllLotto() {
    return this.getAll({ filterBy: (entity) => entity._id.includes(PreviewTypeId.lotto) }).map(marketplace => new MixedLoyaltyItem({ type: 'lotto', data: marketplace }));;
  }
  getAllAuction() {
    return this.getAll({ filterBy: (entity) => entity._id.includes(PreviewTypeId.auction) }).map(marketplace => new MixedLoyaltyItem({ type: 'auction', data: marketplace }));;
  }
  getAllReward() {
    let marketplace = this.getAllMarketplace()
    let lotto = this.getAllLotto()
    let auction = this.getAllAuction()
    return marketplace.concat(lotto, auction)
  }
}
